import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChatFirebaseService } from './chat-firebase.service';

declare var $:any;

@Component({
    selector: 'app-chat-firebase',
    templateUrl: './chat-firebase.component.html',
    styleUrls: ['./chat-firebase.component.scss'],
    providers: [ ChatFirebaseService ]
})

export class ChatFirebaseComponent implements OnChanges {

    @Input() owner;
    @Input() chatId;

    public loggedUser = null;
    public chatData = null;
    public message = "";
    public messages = null;
    public snapShot = null;

    constructor(
        public chatService: ChatFirebaseService
    ) {

    }

    ngOnInit() {
        this.loggedUser = JSON.parse( sessionStorage.getItem('loggedUser') );
    }

    ngOnDestroy() {
        if (this.snapShot) {
            this.snapShot();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        console.log("ngOnChanges",changes);
        if ((changes.chatId) && (this.chatId != "")) {
            if (changes.chatId.currentValue != changes.chatId.previousValue) {
                this.chatService.openChatRoomById(this.chatId, (chatData) => {
                    this.chatData = chatData;
                    this.messages = [];
                    this.snapShot = this.chatData.messages.onSnapshot((data) => {
                        data.docChanges.forEach((change) => {
                            this.messages.push(change.doc.data());
                            //console.log(change.type,change.doc.data());
                            setTimeout(() => {
                                $(".chat-room .h-full").scrollTop($(".chat-room .h-full")[0].scrollHeight);
                            },100);
                        });
                    });
                });
            }
        }
        if (changes.owner) {
            if (changes.owner.currentValue != changes.owner.previousValue) {
                this.chatData = null;
                this.chatService.openChatRoom(this.owner, (chatData) => {
                    this.chatData = chatData;
                    this.messages = [];
                    this.snapShot = this.chatData.messages.onSnapshot((data) => {
                        data.docChanges.forEach((change) => {
                            this.messages.push(change.doc.data());
                            //console.log(change.type,change.doc.data());
                            setTimeout(() => {
                                $(".chat-room .h-full").scrollTop($(".chat-room .h-full")[0].scrollHeight);
                            },100);
                        });
                    });
                });
            }   
        }     
    }

    public sendMessage() {
        if (this.message != "") {
            this.chatService.sendMessage(this.chatData.messagesCollection,this.message);
            this.message = "";
        }
    }




}



// WEBPACK FOOTER //
// ./src/app/@core/components/chat-firebase/chat-firebase.component.ts